var _defs, _rect, _text, _text2, _g, _text3, _text4, _text5, _text6, _text7, _text8, _g2, _g3, _g4, _g5, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWork01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 553 283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1, .st2, .st3 {\n        fill: #fff;\n      }\n\n      .st4 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st2 {\n        font-family: Poppins-Bold, Poppins;\n        font-size: 11px;\n        font-weight: 700;\n      }\n\n      .st5 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st3 {\n        font-family: Poppins-Light, Poppins;\n        font-size: 9px;\n        font-weight: 300;\n      }\n\n      .st6 {\n        fill: none;\n        stroke: url(#linear-gradient4);\n        stroke-miterlimit: 10;\n        stroke-width: .9px;\n      }\n\n      .st7 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 24,
    y1: 117.5,
    x2: 70.4,
    y2: 117.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f37525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcb93f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 295,
    y1: 121.8,
    x2: 341.5,
    y2: 121.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 23.9,
    y1: 215,
    x2: 70.4,
    y2: 215,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 296.5,
    y1: 219.6,
    x2: 342.9,
    y2: 219.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 256.5,
    y1: 57.9,
    x2: 553.1,
    y2: 57.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 553,
    height: 283
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(81.5 105.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Professional designing support"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(82.1 124.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Our highly experienced designers "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10.8
  }, "available round the clock to give "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21.6
  }, "you all kind the of designing "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 32.4
  }, "support."))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 47.2,
    cy: 117.5,
    rx: 23.2,
    ry: 23.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.4,128.9h-14.5c0-.1,0-.2,0-.3,0-1.9,0-3.8,0-5.7,0-2,1.3-3.7,3.2-4.3.5-.2,1-.2,1.5-.2,1.8,0,3.5,0,5.3,0,2.2,0,4.1,1.5,4.5,3.6,0,.3,0,.6,0,.9,0,1.9,0,3.8,0,5.8,0,0,0,.2,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65,127.1h-8.5c0-.2,0-.4,0-.6,0-1.2,0-2.3,0-3.5,0-1.2-.2-2.3-.9-3.3-.6-1-1.5-1.8-2.5-2.3-.1,0-.2-.1-.4-.2.6-.4,1.2-.6,1.8-.7.2,0,.5,0,.7,0,1.7,0,3.5,0,5.2,0,2.5,0,4.6,1.9,4.7,4.4,0,2,0,4,0,6,0,0,0,0,0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.3,127.1c0-.1,0-.2,0-.3,0-1.8,0-3.7,0-5.5,0-1.2.4-2.2,1.1-3.1.9-1,2-1.6,3.4-1.6,1.9,0,3.7,0,5.6,0,.8,0,1.6.2,2.4.7-.2,0-.3.1-.4.2-1.7.8-2.9,2.1-3.3,4-.1.5-.2,1-.2,1.5,0,1.2,0,2.4,0,3.6,0,.2,0,.3,0,.5-.4.1-7.9.2-8.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.8,112.5c0,2.5-2.1,4.6-4.7,4.6-2.6,0-4.7-2.2-4.6-4.8,0-2.5,2.2-4.6,4.7-4.6,2.6,0,4.6,2.1,4.6,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.8,115.3c-2.6,0-4.6-2.1-4.6-4.6,0-2.4,1.9-4.7,4.7-4.7,2.6,0,4.6,2.1,4.6,4.7,0,2.6-2.1,4.6-4.7,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.6,115.3c-2.6,0-4.7-2.1-4.7-4.6,0-2.5,1.9-4.6,4.6-4.7,2.6,0,4.7,2,4.7,4.6,0,2.6-2,4.7-4.7,4.7Z"
  })))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(354.3 105.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Complete in-house binding"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(355 124.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Quality is one of the reasons that "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10.8
  }, "make us among the top choice of "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21.6
  }, "clients to enhance the printing quality"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(81.8 200.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Advanced use of technology"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(82.5 219.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "The latest technology offset printing "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10.8
  }, "machine, coupled with the "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21.6
  }, "proficiency of our technical team, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 32.4
  }, "can help"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(354.3 201.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Quick delivery of service"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(355 219.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Depending on the requirements of the "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10.8
  }, "service, we do not stretch it long to "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21.6
  }, "deliver the service. "))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 318.2,
    cy: 121.8,
    rx: 23.2,
    ry: 23.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.9,117.3c.5.1,1,.2,1.4.5,1.5.7-.2.7-.9.9,0,0,.3.5.3.6.6,1.3.4,4-1,4.9l.7.2c.4.7-.4.7-.8,1-.8.5-.9,2.1-.7,3,.5.3,1.3.3,1.8.7s.3.3.1.4l-16.2,3.9-10.9-3.5c-1.5-.7-1.7-3.6-1.2-4.9s.4-.5.5-.8c-.8-.1-1.1-.3-.2-.7s1.2-.3,1.5-.5,0-2-.1-2.4c-.3-.7-.7-.5-1.2-.9s-.4-.4-.1-.6,1.1-.3,1.4-.4l-.5-.7c-.6-1.3-.8-3.8.4-4.8s2.4-.6,3.3-.8c4.6-.7,9.2-1.2,13.8-1.9l10.1,3.1c.3.7-.7.7-1,1-.6.6-.7,2.1-.5,2.9ZM316.9,117.2l-10.4-3.4c-.7-.2-1.1.4-1.1,1s0,2.5.8,2.9l10.5,3v-.2c.1,0,.2-3.4.2-3.4ZM330.6,114.6l-13.1,2.7c-.3,1.1,0,2.4-.2,3.5l13-3.2c0-1-.1-2,.3-3ZM319.7,126.2l10.7-3c.9-.5,1-3.4.2-3.9s-.4-.1-.6,0l-10.4,3.4v3.6ZM319,122.7l-13.1-2.7c.5,1,.3,2,.3,3l12.8,3.2c.2,0,0,0,.1-.1,0-.3,0-.6,0-.8,0-.4,0-2.4,0-2.5ZM315.9,128.2l-10.5-3.4c-.3,0-.6.2-.8.4-.4.8-.3,3.1.5,3.6l10.7,3v-3.5ZM316.4,131.7l13-3.2h0c-.2-1.1-.1-2.1.2-3-2.7.7-5.5,1-8.3,1.7s-1.2.4-2.2.4-1.8.5-2.7.5l-.2,3.5Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 47.2,
    cy: 215,
    rx: 23.2,
    ry: 23.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.5,225.1c-.3.3-1.2.5-1.7.8s-1.1.9-1.3,1.4-.1,1.4-.9,1.5-2.5,0-2.8,0c-.4-.2-.5-1.2-.8-1.7-.8-1.5-3.5-2.5-5.1-1.8s-.8.8-1.6.3-1.6-1.5-1.7-1.7c-.4-.7.5-1.4.6-2.2.2-1.4-.8-3.7-2.1-4.4s-1.6-.2-1.7-1,0-2.1,0-2.5c.1-.7.7-.6,1.2-.8,1.9-.7,3.1-3.6,2.2-5.4s-.8-.8-.1-1.7,1.5-1.5,1.7-1.6c.6-.3,1.5.6,2.3.7,1.4.2,3.5-.8,4.2-2s.3-1.5.8-1.6,2.7-.1,3,0c.4.2.5,1.2.7,1.6.7,1.4,1.7,1.2,2.7,1.9s.5,1.3.4,2-.4.6-.9.6c-2.4.2-4.9-.4-7.3.5-6.2,2.5-6.4,11.5-.2,14.1s4.8.3,7.5.6.8.1.9.7,0,1.5-.2,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.6,211h-4.2c-.5.2-2.4,2.5-3,2.9s-.9.4-1.4.4c-2.8.2-5.9-.2-8.7,0-1.1,0-1.3-1.9-.2-2.1h9.2c1.1-.8,2.6-3.2,3.9-3.3s3,.1,4.4,0c1-2.2,4.2-2.3,5.1,0,1.2,3.3-3.6,5.2-5,2ZM62.7,208.7c-.9.2-1.2,1.8-.3,2.3s2.4-.6,1.7-1.7-.9-.7-1.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.1,219c-.3-.3-.6-.9-.9-1.1h-11c-1,0-1-1.9,0-2h11.1c.3,0,.3-.4.5-.6,1.7-2.2,5.1-.8,4.8,2s-2.8,3-4.4,1.7ZM57.7,217.8c1.1-1.2-.6-2.9-1.8-1.8s.6,3.1,1.8,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.8,202.7c2.3-.4,4,2.3,2.6,4.2s-1.9,1.1-3.1,1.1c-.7.6-1.8,2.4-2.7,2.6-2.1-.1-4.5.3-6.5,0s-.9-1.8-.2-1.9h5.9c.2,0,.3,0,.4-.2s1.5-1.6,1.6-1.7c0-.3-.2-.6-.2-.9-.2-1.5.7-3,2.2-3.2ZM53,204.1c-1.5.2-1.4,2.3-.1,2.5,2,.3,2-2.7.1-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.9,219.5c2.1.1,4.4-.2,6.4,0s.9.2,1.2.6,1.1,1.5,1.5,1.6,1.1,0,1.6,0c3,.9,2.2,5.7-1.3,5.2s-2.7-2.4-1.9-4c-.5-.4-1-1.4-1.7-1.5h-6c-.7-.2-.6-1.8,0-1.9ZM52.7,223.1c-1.6.2-1.4,2.8.4,2.5s1.1-2.7-.4-2.5Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 319.7,
    cy: 219.6,
    rx: 23.2,
    ry: 23.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.8,224.2l12.9-9.6-.2-.6-14.2,8.9c-.7.8-.4,4.1-1.1,5.2-.4,0-.2-.3-.3-.6-.4-2.2-.9-4.3-1.3-6.5-1.4-1.4-3.4-2.5-4.8-3.9s-.8-.6-.6-1.2l30.4-8,.8.3v.7s-12.7,22-12.7,22h-.4c0,0-8.3-6.3-8.3-6.3v-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.6,227.6l-2.7,1.4-.3-.2.5-3.2c.3,0,.4,0,.6.2.3.2,1.5,1.2,1.7,1.4s.2.1.2.4Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.4,50.8l-3.9-15.9h2.4c1.4,6.1,2.5,10.8,2.8,13.4h0c.4-2.3,2.3-9.5,3.3-13.4h2.1c.9,3.5,2.8,11,3.2,13.3h0c.5-3,2.4-10.1,3.1-13.3h2.2l-4.2,15.9h-2.4c-.9-3.7-2.6-10.5-3.1-12.8h0c-.5,2.5-2.3,9.3-3.1,12.8h-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.5,34v6.7c.6-1.1,1.7-1.9,3.5-1.9s3.7.9,3.7,4.2v7.8h-2.1v-7.4c0-1.7-.6-2.7-2.3-2.7s-2.7,1.2-2.7,3.5v6.7h-2.1v-16.8h2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.6,39.1c1.7,5.6,2.7,8.4,2.9,9.8h0c.3-1.3,1.4-5,2.9-9.8h2.2l-4.1,12.3c-1.2,3.6-2.3,4.3-4.3,4.3s-.8,0-1,0v-1.8c.3,0,.7,0,1,0,1.3,0,1.8-1,2.3-2.6l-4.2-12.2h2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.7,50.8l-3.9-15.9h2.4c1.4,6.1,2.5,10.8,2.8,13.4h0c.4-2.3,2.3-9.5,3.3-13.4h2.1c.9,3.5,2.8,11,3.2,13.3h0c.5-3,2.4-10.1,3.1-13.3h2.2l-4.2,15.9h-2.4c-.9-3.7-2.6-10.5-3.1-12.8h0c-.5,2.5-2.3,9.3-3.1,12.8h-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.4,45.4c0,2.2.9,3.9,2.9,3.9s2.3-1.2,2.6-1.8h2.1c-.4,1.6-1.6,3.6-4.8,3.6s-5-2.8-5-6.1,1.4-6.1,5.1-6.1,4.8,2.9,4.8,5.6,0,.8,0,.9h-7.7ZM333.1,43.8c0-1.9-.8-3.3-2.8-3.3s-2.7,2-2.8,3.3h5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.6,46.2l-1.5,4.6h-2.2c.9-2.8,4.1-12.7,5.1-15.9h2.8l5.4,15.9h-2.4l-1.5-4.6h-5.7ZM350.9,44.3c-1.3-3.9-2.1-6.3-2.4-7.6h0c-.4,1.9-1.2,4.3-2.3,7.6h4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.3,43c0-1.9,0-3.4,0-4h2.1c0,.5,0,1.3,0,2.3.5-1.4,1.8-2.5,3.8-2.5v2.2c-2.6,0-3.7,1.5-3.7,4v5.7h-2.1v-7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.4,45.4c0,2.2.9,3.9,2.9,3.9s2.3-1.2,2.6-1.8h2.1c-.4,1.6-1.6,3.6-4.8,3.6s-5-2.8-5-6.1,1.4-6.1,5.1-6.1,4.8,2.9,4.8,5.6,0,.8,0,.9h-7.7ZM372.1,43.8c0-1.9-.8-3.3-2.8-3.3s-2.7,2-2.8,3.3h5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.5,36.8h-4.6v-1.9h11.4v1.9h-4.6v14h-2.2v-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.2,34v6.7c.6-1.1,1.7-1.9,3.5-1.9s3.7.9,3.7,4.2v7.8h-2.1v-7.4c0-1.7-.6-2.7-2.3-2.7s-2.7,1.2-2.7,3.5v6.7h-2.1v-16.8h2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408.1,45.4c0,2.2.9,3.9,2.9,3.9s2.3-1.2,2.6-1.8h2.1c-.4,1.6-1.6,3.6-4.8,3.6s-5-2.8-5-6.1,1.4-6.1,5.1-6.1,4.8,2.9,4.8,5.6,0,.8,0,.9h-7.7ZM413.7,43.8c0-1.9-.8-3.3-2.8-3.3s-2.7,2-2.8,3.3h5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M424.2,34.9h5.7c3,0,4.7,1.5,4.7,4s-1.3,3-2.2,3.3c1.1.4,2.7,1.5,2.7,3.9s-2.2,4.7-5.4,4.7h-5.5v-15.9ZM429.4,41.4c2.2,0,3-.8,3-2.4s-.9-2.4-2.9-2.4h-3.2v4.8h3ZM426.4,49.1h3.1c1.9,0,3.3-.9,3.3-3s-1.2-2.9-3.5-2.9h-2.9v5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M439.2,45.4c0,2.2.9,3.9,2.9,3.9s2.3-1.2,2.6-1.8h2.1c-.4,1.6-1.6,3.6-4.8,3.6s-5-2.8-5-6.1,1.4-6.1,5.1-6.1,4.8,2.9,4.8,5.6,0,.8,0,.9h-7.7ZM444.8,43.8c0-1.9-.8-3.3-2.8-3.3s-2.7,2-2.8,3.3h5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M450.6,47.4c.2,1.3,1.2,2,2.5,2s2.1-.8,2.1-1.7-.7-1.5-2.7-2c-2.9-.8-3.7-1.9-3.7-3.4s1-3.3,4-3.3,4,1.6,4.2,3.4h-2.1c-.2-.9-.6-1.8-2.2-1.8s-1.8.6-1.8,1.5.4,1.3,2.4,1.8c3,.8,4,1.9,4,3.7s-1.8,3.6-4.4,3.6-4.3-1.2-4.6-3.6h2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M458.4,39.1h1.8v-3.4h2.1v3.4h2.3v1.7h-2.3v7.1c0,.9.2,1.3,1.2,1.3s.6,0,.9,0v1.6c-.5.2-1.2.2-1.6.2-1.8,0-2.6-.7-2.6-2.7v-7.5h-1.8v-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.6,34.9h5.4c3,0,5.2,1.5,5.2,4.5s-2.2,4.7-5.5,4.7h-3v6.7h-2.2v-15.9ZM474.8,42.3h2.8c2,0,3.3-.7,3.3-2.9s-1.3-2.7-3.3-2.7h-2.9v5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M485.4,43c0-1.9,0-3.4,0-4h2.1c0,.5,0,1.3,0,2.3.5-1.4,1.8-2.5,3.8-2.5v2.2c-2.6,0-3.7,1.5-3.7,4v5.7h-2.1v-7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M493.2,34h2.1v2.6h-2.1v-2.6ZM493.2,39.1h2.1v11.8h-2.1v-11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M498.6,42.7c0-2.4,0-3.2,0-3.7h2.1c0,.2,0,1.3,0,1.8.5-1,1.6-2,3.4-2s3.7,1.3,3.7,4.4v7.6h-2.2v-7.3c0-1.6-.5-2.9-2.2-2.9s-2.8,1.4-2.8,3.8v6.3h-2.1v-8.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M509.6,39.1h1.8v-3.4h2.1v3.4h2.3v1.7h-2.3v7.1c0,.9.2,1.3,1.2,1.3s.6,0,.9,0v1.6c-.5.2-1.2.2-1.6.2-1.8,0-2.6-.7-2.6-2.7v-7.5h-1.8v-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.2,45.4c0,2.2.9,3.9,2.9,3.9s2.3-1.2,2.6-1.8h2.1c-.4,1.6-1.6,3.6-4.8,3.6s-5-2.8-5-6.1,1.4-6.1,5.1-6.1,4.8,2.9,4.8,5.6,0,.8,0,.9h-7.7ZM524.9,43.8c0-1.9-.8-3.3-2.8-3.3s-2.7,2-2.8,3.3h5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M529.5,43c0-1.9,0-3.4,0-4h2.1c0,.5,0,1.3,0,2.3.5-1.4,1.8-2.5,3.8-2.5v2.2c-2.6,0-3.7,1.5-3.7,4v5.7h-2.1v-7.8Z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 553.1,
    y1: 57.9,
    x2: 256.5,
    y2: 57.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork01);
export default __webpack_public_path__ + "static/media/work-01.7895e34c831b68bd7bf3411b5b268190.svg";
export { ForwardRef as ReactComponent };